module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-4 columns-withpadding"
  }, [_c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "section has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "https://pisciculturaglobal.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Piscicultura Global"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-8"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Registrarme")])], 1), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('message-system', {
    attrs: {
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input email-input",
    class: {
      'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "placeholder": "Nombre de Usuario",
      "autocomplete": "off",
      "name": "username",
      "data-vv-as": "nombre de usuario"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input password-input",
    class: {
      'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "placeholder": "●●●●●●●",
      "name": "password",
      "data-vv-as": "contraseña"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    staticClass: "control login"
  }, [_c('button', {
    staticClass: "button is-info is-outlined is-fullwidth",
    attrs: {
      "type": "submit",
      "disabled": _vm.processing
    }
  }, [_vm._v("Iniciar Sesión")])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('in-button', {
    attrs: {
      "api": _vm.api.linkedin
    },
    on: {
      "status": _vm.communication
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('g-button', {
    attrs: {
      "api": _vm.api.google
    },
    on: {
      "status": _vm.communication
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('fb-button', {
    attrs: {
      "api": _vm.api.facebook
    },
    on: {
      "status": _vm.communication
    }
  })], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8 is-hidden-mobile hero-banner columns-withpadding",
    attrs: {
      "id": "image-background"
    }
  }, [_c('section', {
    staticClass: "hero is-fullheight is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Bienvenido")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "title is-3"
  }, [_vm._v("Inicia sesión en Piscicultura Global")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon user"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon user"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olvide mi Contraseña")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b96e6a","hasScoped":true}!./src/pages/login/template.html
// module id = 397
// module chunks = 1